import { $WC, $DKD } from '@/conf/common.const.js';
import gripUtil from "@/lib/grip.util.js";
import commonApi from "@/api/common.api.js";

export default {
    state: {
        // 행정동 인구 기준일
        hjdPopulationBaseDay: '',
        // 행정동 별 인구
        hjdPopulationList: [],
        // 장애인 인구 기준일
        hjdDisaledPopulationBaseDay: '',
        // 장애인 인구
        hjdDisaledPopulationList: [],
        // 기초수급자 인구 기준일
        hjdPensionerPopulationBaseDay: '',
        // 기초수급자 인구
        hjdPensionerPopulationList: [],
        // 생활인구 목록 (내국인) 기준일
        localLifePopulationBaseDay: '',
        // 생활인구 목록 (내국인)
        localLifePopulationList: [],
        // 생활인구 시간 별 맵(내국인)
        localLifePopulationMap: {},
        // 생활인구 목록 (단기체류 외국인) 기준일
        shrotStayPopulationBaseDay: '',
        // 생활인구 목록(단기체류 외국인)
        shrotStayPopulationList: [],
        // 생활인구 맵(단기체류 외국인)
        shrotStayPopulationMap: {},
        // 생활인구 목록 (장기체류 외국인) 기준일
        longStayPopulationBaseDay: '',
        // 생활인구 목록(장기체류 외국인)
        longStayPopulationList: [],
        // 생활인구 맵(장기체류 외국인)
        longStayPopulationMap: {},
    },
    getters: {
        getHjdPopulationBaseDay(state) {
            return state.hjdPopulationBaseDay;
        },
        getHjdPopulationList(state) {
            return state.hjdPopulationList;
        },
        getHjdDisaledPopulationBaseDay(state) {
            return state.hjdDisaledPopulationBaseDay;
        },
        getHjdDisaledPopulationList(state) {
            return state.hjdDisaledPopulationList;
        },
        getHjdPensionerPopulationBaseDay(state) {
            return state.hjdPensionerPopulationBaseDay;
        },
        getHjdPensionerPopulationList(state) {
            return state.hjdPensionerPopulationList;
        },
        getLocalLifePopulationBaseDay(state) {
            return state.localLifePopulationBaseDay;
        },
        getLocalLifePopulationList(state) {
            return state.localLifePopulationList;
        },
        getLocalLifePopulationMap(state) {
            return state.localLifePopulationMap;
        },
        getShrotStayPopulationBaseDay(state) {
            return state.shrotStayPopulationBaseDay;
        },
        getShrotStayPopulationList(state) {
            return state.shrotStayPopulationList;
        },
        getShrotStayPopulationMap(state) {
            return state.shrotStayPopulationMap;
        },
        getLongStayPopulationBaseDay(state) {
            return state.longStayPopulationBaseDay;
        },
        getLongStayPopulationList(state) {
            return state.longStayPopulationList;
        },
        getLongStayPopulationMap(state) {
            return state.longStayPopulationMap;
        },
    },
    mutations: {
        HJD_POPULATION_BASE_DAY(state, hjdPopulationBaseDay) {
            state.hjdPopulationBaseDay = hjdPopulationBaseDay;
        },
        HJD_POPULATION_LIST(state, hjdPopulationList) {
            state.hjdPopulationList = hjdPopulationList;
        },
        HJD_DISALED_POPULATION_BASE_DAY(state, hjdDisaledPopulationBaseDay) {
            state.hjdDisaledPopulationBaseDay = hjdDisaledPopulationBaseDay;
        },
        HJD_DISABLED_POPULATION_LIST(state, hjdDisaledPopulationList) {
            state.hjdDisaledPopulationList = hjdDisaledPopulationList;
        },
        HJD_PENSIONER_POPULATION_BASE_DAY(state, hjdPensionerPopulationBaseDay) {
            state.hjdPensionerPopulationBaseDay = hjdPensionerPopulationBaseDay;
        },
        HJD_PENSIONER_POPULATION_LIST(state, hjdPensionerPopulationList) {
            state.hjdPensionerPopulationList = hjdPensionerPopulationList;
        },
        LOCAL_LIFE_POPULATION_BASE_DAY(state, localLifePopulationBaseDay) {
            state.localLifePopulationBaseDay = localLifePopulationBaseDay;
        },
        LOCAL_LIFE_POPULATION_LIST(state, localLifePopulationList) {
            state.localLifePopulationList = localLifePopulationList;
        },
        LOCAL_LIFE_POPULATION_MAP(state, localLifePopulationMap) {
            state.localLifePopulationMap = localLifePopulationMap;
        },
        SHROT_STAY_POPULATION_BASE_DAY(state, shrotStayPopulationBaseDay) {
            state.shrotStayPopulationBaseDay = shrotStayPopulationBaseDay;
        },
        SHORT_STAY_POPULATION_LIST(state, shrotStayPopulationList) {
            state.shrotStayPopulationList = shrotStayPopulationList;
        },
        SHROT_STAY_POPULATION_MAP(state, shrotStayPopulationMap) {
            state.shrotStayPopulationMap = shrotStayPopulationMap;
        },
        LONG_STAY_POPULATION_BASE_DAY(state, longStayPopulationBaseDay) {
            state.longStayPopulationBaseDay = longStayPopulationBaseDay;
        },
        LONG_STAY_POPULATION_LIST(state, longStayPopulationList) {
            state.longStayPopulationList = longStayPopulationList;
        },
        LONG_STAY_POPULATION_MAP(state, longStayPopulationMap) {
            state.longStayPopulationMap = longStayPopulationMap;
        },
    },
    actions: {
        FETCH_HJD_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.POP_HJD_AGE)
                .then(res => {
                    let hjdPopulationList = res.data.data;
                    if(typeof hjdPopulationList !== 'undefined') {
                        commit("HJD_POPULATION_BASE_DAY", hjdPopulationList[0].basdtVal);
                    }
                    commit('HJD_POPULATION_LIST', hjdPopulationList);
                });
        },
        FETCH_HJD_DISABLED_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.POP_DISABLED)
                .then(res => {
                    let hjdDisaledPopulationList = res.data.data;
                    if(typeof hjdDisaledPopulationList !== 'undefined') {
                        commit("HJD_DISALED_POPULATION_BASE_DAY", hjdDisaledPopulationList[0].basdtVal);
                    }
                    commit('HJD_DISABLED_POPULATION_LIST', hjdDisaledPopulationList);
                });
        },
        FETCH_HJD_PENSIONER_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.POP_PENSIONER)
                .then(res => {
                    let hjdPensionerPopulationList = res.data.data;
                    if(typeof hjdPensionerPopulationList !== 'undefined') {
                        commit("HJD_PENSIONER_POPULATION_BASE_DAY", hjdPensionerPopulationList[0].basdtVal);
                    }
                    commit('HJD_PENSIONER_POPULATION_LIST', hjdPensionerPopulationList);
                });
        },
        FETCH_LOCAL_LIFE_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.LIFE_POP_LOCAL)
                .then(res => {
                    let localLifePopulationList = res.data.data;
                    if(typeof localLifePopulationList !== 'undefined') {
                        commit("LOCAL_LIFE_POPULATION_BASE_DAY", localLifePopulationList[0].basdtVal);
                    }

                    commit('LOCAL_LIFE_POPULATION_LIST', localLifePopulationList);
                    let localPopulationMap = gripUtil.toMap(localLifePopulationList, 'val3');
                    commit('LOCAL_LIFE_POPULATION_MAP', localPopulationMap);
                });
        },
        FETCH_SHORT_STAY_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.LIFE_POP_SHORT)
                .then(res => {
                    let shortStayPopulationList = res.data.data;
                    if(typeof shortStayPopulationList !== 'undefined') {
                        commit("SHROT_STAY_POPULATION_BASE_DAY", shortStayPopulationList[0].basdtVal);
                    }

                    commit('SHORT_STAY_POPULATION_LIST', shortStayPopulationList);
                    let shortStayPopulationMap = gripUtil.toMap(shortStayPopulationList, 'val3');
                    commit('SHROT_STAY_POPULATION_MAP', shortStayPopulationMap);
                });
        },
        FETCH_LONG_STAY_POPULATION_LIST({commit}) {
            return commonApi.fetchMaxBasdtValDataList($DKD.LIFE_POP_LONG)
                .then(res => {
                    let longStayPopulationList = res.data.data;
                    if(typeof longStayPopulationList !== 'undefined') {
                        commit("LONG_STAY_POPULATION_BASE_DAY", longStayPopulationList[0].basdtVal);
                    }

                    commit('LONG_STAY_POPULATION_LIST', longStayPopulationList);
                    let longStayPopulationMap = gripUtil.toMap(longStayPopulationList, 'val3');
                    commit('LONG_STAY_POPULATION_MAP', longStayPopulationMap);
                });
        },
    }
}
